import { ACTION_TYPE, fetchJson } from '../../store/actionCreatorsHelpers';

export function fetchApp(appId: string, pageDomain: string) {
    return {
        type: ACTION_TYPE.REQUEST_APP,
        appId,
        payload: fetchJson(`api/apps/${appId}`),
        meta: { pageDomain },
    };
}

export function clickLink(appId: string, url: string) {
    return {
        type: ACTION_TYPE.CLICK_LINK,
        appId,
        url,
    };
}

export function copyPermalink(appId: string) {
    return {
        type: ACTION_TYPE.COPY_PERMALINK,
        appId,
    };
}
